import React, {useState} from 'react';
import {useStaticQuery, graphql} from 'gatsby';
import PureHeader from './PureHeader';
import './Header.less';

const HeaderWrapper = ({locale}) => {
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

    const toggleMobileMenu = () => {
        setIsMobileMenuOpen(!isMobileMenuOpen);
    };

    const handleMouseDown = (e) => {
        toggleMobileMenu();
        e.stopPropagation();
    };

    const data = useStaticQuery(graphql`
        query {
            header {
                data
            }
            allContentfulNavigation(
                filter: {items: {elemMatch: {url: {ne: null}}}}
            ) {
                nodes {
                    items {
                        label
                        url
                    }
                    node_locale
                    buttonLabel
                    buttonLink
                }
            }
        }
    `);

    const hasNav = data.allContentfulNavigation.nodes.find((node) => {
        return node.node_locale === locale;
    });

    const logo = JSON.parse(data.header.data).logo;

    if (hasNav) {
        const {items, buttonLabel, buttonLink} = hasNav;

        const hideSearchLocales = ['en-AU', 'en-NZ'];

        return (
            <header role="banner">
                <div className="Header--wrapper">
                    <PureHeader
                        logo={logo}
                        logoNavClass="Header__logo--with-nav"
                        navItems={items}
                        search={{
                            label: buttonLabel,
                            url: buttonLink,
                        }}
                        handleClick={handleMouseDown}
                        handleToggle={toggleMobileMenu}
                        isOpen={isMobileMenuOpen}
                        locale={locale}
                        hiddenSearchBtnClass={
                            hideSearchLocales.includes(locale)
                                ? 'hidden-sm'
                                : null
                        }
                    />
                </div>
            </header>
        );
    }
    return <PureHeader logo={logo} logoNavClass="Header__logo--without-nav" />;
};

export default HeaderWrapper;
